import React, { useState, useEffect } from "react";
import { NavDropdown } from "react-bootstrap";
import "../css/ProductDropdown.css";
import { useLocation } from "react-router-dom";

const productCategories = [
  {
    title: "Instrumentation",
    subCategories: [
      { title: "Field Instruments", items: ["Gauges", "Transmitter"] },
      { title: "Fire & Gas Detection System", items: ["Fire Alarm System", "Gas Detection System"] },
      { title: "Testing Instruments", items: ["Digital Multimeter", "Battery Tester", "Tachometer"] },
      { title: "Enclosure & Panel", items: [] },
      {
        title: "Measuring & Analytical Instruments",
        items: ["Flow Meter", "Flow Computer", "Electronic Volume Corrector", "Gas Chromatograph", "Gas Analyser"]
      }
    ]
  },
  {
    title: "Electrical",
    subCategories: [
      { title: "Lighting", items: ["LED", "SOLAR"] },
      { title: "Battery", items: ["Automotive", "Industrial"] },
      { title: "Wires and Cables", items: ["Single Core Cable", "Multi Core Cable", "Flexible Cable", "Accessories (Lugs, Terminals, Connectors)"] },
      { title: "Relays", items: ["Protection Relay", "Earth Fault Relay", "Earth Leakage Relay", "APFC Relay"] },
      { title: "Control Gear & Signalling Devices", items: ["Power Contactor", "Over load Relay", "MPCB", "Push Button", "Indicating Lamps", "Motor Starter"] },
    ]
  },
  { title: "General Category", items: ["Office Stationery", "Paint", "E-House", "Consumable"] },
  {
    title: "Mechanical",
    items: ["Pipe", "Fittings & Flanges", "Valves", "Pressure Safety Valve", "Bearing", "Gasket", "Anchor Fasteners", "Tools & Tackles", "UPVC & CPVC Pipe, Fittings"]
  },
  { title: "Telecom System", items: ["OTDR", "Power Source & Meter", "CCTV System", "EPABX System", "Optical Fiber Cable", "Accessories"] },
  { title: "Safety Items", items: [] }
];

interface ProductDropDownProperty
{
    toggleMenu : any;
}
const ProductDropdown: React.FC<ProductDropDownProperty> = ({toggleMenu}) => {
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const [activeSubCategory, setActiveSubCategory] = useState<string | null>(null);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    const updateMobileStatus = () => {
      setIsMobile(window.innerWidth < 768);
    };
    updateMobileStatus();
    window.addEventListener("resize", updateMobileStatus);
    return () => window.removeEventListener("resize", updateMobileStatus);
  }, []);
   
  const isActive = (path: string, level: number) => {
    const cleanedPath = path.replace("#", "").toLowerCase(); // Normalize case
    const currentPath = location.pathname.split("/");
   if(currentPath.length < level ) return "";
  const currentpage=currentPath[level];
  if(currentpage == null || currentpage ==="" ) return""; 
  if(currentpage.toLowerCase() === cleanedPath.toLowerCase() )   
    return "active";
  else return "";
  }
  return (
    <NavDropdown title="Products" id="nav-dropdown" className={`custom-dropdown ${isActive("products",1)}`} >
      {productCategories.map((category, index) => (
        <div
          key={index}
          className={`dropdown-item category-item ${isActive(category.title,2)}`}
          onClick={() => setActiveCategory(activeCategory === category.title ? null : category.title)}
          onMouseEnter={() => !isMobile && setActiveCategory(category.title)}
          onMouseLeave={() => !isMobile && setActiveCategory(null)}
        >
        {(!category.subCategories && category.items.length === 0) ? (
  <a 
    onClick={toggleMenu} 
    href={`/#/products/${encodeURIComponent(category.title)}`}
  >
    {category.title}
  </a>
) : (
  category.title
)}           {category.subCategories && activeCategory === category.title && (
            <div className={`sub-menu  ${isMobile ? "bottom" : "left"}`}>
              {category.subCategories.map((subCat, subIndex) => (
                <div
                  key={subIndex}
                  className={`dropdown-item subcategory-item ${isActive(category.title,3)}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveSubCategory(activeSubCategory === subCat.title ? null : subCat.title);
                   
                  }}
                  onMouseEnter={() => !isMobile && setActiveSubCategory(subCat.title)}
                  onMouseLeave={() => !isMobile && setActiveSubCategory(null)}
                >
                  {/* <span className="arrow">{activeSubCategory === subCat.title ? "<<" : " "}</span> */}
                  {subCat?.items?.length? (
                                    <>
                  {subCat.title}{" "}
                  {subCat.items && subCat.items.length > 0 && activeSubCategory === subCat.title && (
                    <div className={`item-menu ${isMobile ? "bottom" : "left"}`}>
                      {subCat.items.map((item, itemIndex) => (
                        <a key={itemIndex} onClick={(e)=>toggleMenu(e,false,true)} className="dropdown-item" href={`/#/products/${activeCategory}/${encodeURIComponent(item)}`}>
                          {item}
                        </a>
                      ))}
                     </div>
                  )}
                    </>) :           (
                        
                        <a  onClick={(e)=>toggleMenu(e,false,true)}  href={`/#/products/${activeCategory}/${encodeURIComponent(subCat.title)}`}>
                          {subCat.title}
                        </a>
                                          )}
                </div>
              ))}
            </div>
          )}
             {/* Direct Items (for categories without subcategories) */}
             {category.items && activeCategory === category.title && (
            <div className="sub-menu left">
              {category.items.map((item, itemIndex) => (
                <a
                  key={itemIndex}
                  href={`#/Products/${category.title}/${encodeURIComponent(item)}`}
                  className={`dropdown-item ${isActive(encodeURIComponent(item),3)}`}
                  onClick={(e)=>toggleMenu(e,false,true)}
                >
                  {item}
                </a>
              ))}
            </div>
          )}
        </div>
      ))}
      </NavDropdown>
  );
};

export default ProductDropdown;
